import { createStore } from 'vuex';
import auth from "./auth";
import professional from "./professional";
import queue from './queue'
import sncr from './sncr'
export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth: auth,
    professional: professional,
    queue: queue,
    sncr: sncr,
  }
})
